<template>
  <div class="dealers-list">
    <top-bar
      title="Asignación de Evaluaciones"
      :show-add-button="true"
      add-button-label="Asignar Evaluación"
      @addItem="$router.push({name: 'assignments-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        >
          <router-link
            slot-scope="{row}"
            slot="name"
            :to="{name:'dealers-view', params:{id:row.id}}"
          >{{ row.name }}
          </router-link>
        </ms-grid>
      </div>
    </scrollable-container>
    <router-view/>
  </div>
</template>

<script>
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'
import DefaultGuards from '@/guards/default.guards'
import DefaultActions from '@/helpers/default-actions'

export default {
  name: 'LayoutList',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      columns: [
        {
          label: 'ID',
          property: 'id',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'layout.name',
          sortable: false
        },
        {
          label: 'División',
          property: 'layout.division',
          sortable: false
        },
        {
          label: 'Inicio',
          property: 'startDate',
          type: 'date'
        },
        {
          label: 'Fin',
          property: 'endDate',
          type: 'date'
        },
        {
          label: 'Periodo',
          property: 'period.name'
        }
      ],
      options: {
        selectable: false,
        actions: [DefaultActions.delete('assignments')]
      }
    }
  },
  computed: {
    ...mapGetters('assignments', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    randomStar () {
      return Math.ceil(Math.random() * 5)
    }
  },
  beforeRouteUpdate: DefaultGuards.onQuery(
    'assignments',
    { with: 'layout, period' },
    ['name']
  ),
  beforeRouteEnter: DefaultGuards.onQuery(
    'assignments',
    { with: 'layout, period' },
    ['name']
  )
}
</script>

<style scoped>
.dealer-list {
  max-height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/app/assignments/assignments-list-view.vue